export enum ViewMode {
  DRAFT = 'DRAFT',
  UPLOAD = 'UPLOAD',
  IN_REVIEW = 'IN_REVIEW',
  DENIED = 'DENIED',
  APPROVED = 'APPROVED',
  IMAGES = 'IMAGES',
  MEDIA = 'MEDIA',
  REPORTS = 'REPORTS',
  SUBMISSIONS = 'SUBMISSIONS',
}
